import { IHeaderState } from "@/store/modules/header/interface";

export default <IHeaderState> {
	mainButtonClickedKey: 0,
	mainButtonVisibility: false
}